// Printing service updated to delegate printing to local backend at http://localhost:8082
// ES modules only

const PRINTER_SERVER = 'http://localhost:8082';

function toNumber(value) {
  const n = Number(value);
  return Number.isFinite(n) ? n : 0;
}

export async function connectPrinter() {
  // No device connection needed; just probe the local printer backend
  try {
    const res = await fetch(`${PRINTER_SERVER}/health`, { method: 'GET' });
    if (!res.ok) throw new Error('Printer backend not reachable');
    return true;
  } catch (e) {
    // Do not throw to keep UX smooth; return false so UI can still proceed
    return false;
  }
}

export function isPrinterConnected() {
  // We cannot reliably know; return true to avoid blocking UI
  return true;
}

export async function disconnectPrinter() {
  // No-op in backend-driven printing
  return true;
}

export async function printSaleReceipt({
  business,
  sale,
  cart,
  payments,
  deliveryPrice,
  totals,
  options
}) {
  const items = Array.isArray(cart) ? cart.map((it) => {
    const qty = toNumber(it.qty);
    const price = toNumber(it.price);
    return {
      name: it.name || '',
      price,
      qty,
      sum: qty * price,
      barcode: it.batch_barcode || undefined
    };
  }) : [];

  const totalProducts = items.reduce((s, it) => s + toNumber(it.sum), 0);
  const delivery = toNumber(deliveryPrice || 0);
  const overall = totalProducts + (delivery > 0 ? delivery : 0);

  const payload = {
    business: business || {},
    sale: sale || {},
    items,
    totals: {
      totalProducts,
      deliveryPrice: delivery > 0 ? delivery : 0,
      overall: delivery > 0 ? overall : totalProducts
    },
    payments: Array.isArray(payments) ? payments : [],
    options: options || {}
  };

  const res = await fetch(`${PRINTER_SERVER}/print`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(payload)
  });
  if (!res.ok) {
    const errText = await res.text().catch(() => '');
    throw new Error(errText || 'Printer backend error');
  }
  return await res.json().catch(() => ({ ok: true }));
}

export default {
  connectPrinter,
  isPrinterConnected,
  disconnectPrinter,
  printSaleReceipt,
};

// Simple test print to validate backend connectivity
export async function testPrint() {
  const res = await fetch(`${PRINTER_SERVER}/print-test`, {
    method: 'GET'
  });
  if (!res.ok) {
    const t = await res.text().catch(() => '');
    throw new Error(t || 'Printer test failed');
  }
  return await res.json().catch(() => ({ ok: true }));
}


